<template>
<div class="audio-box">
    <!-- 此处的ref属性，可以很方便的在vue组件中通过 this.$refs.audio获取该dom元素 -->
    <audio ref="audio" @pause="onPause" @play="onPlay" @timeupdate="onTimeupdate" @loadedmetadata="onLoadedmetadata" :src="music.url"
        controls="controls" style="display:none;"></audio>

    <!-- 音频播放控件 -->
    <div class="audio-cont" @click="startPlayOrPause">
      <div class="audio-left">
        <span :class="['play',audio.playing?'active':'']"></span>
        <!-- <button @click="startPlayOrPause">{{audio.playing | transPlayPause}}</button> -->
        <!-- <div class="slider" @touchstart="handleTouchStart">
            <div class="slider-track"></div>
            <div class="slider-fill" :style="'width:'+sliderTime+'%'"></div>
            <div class="slider-thumb" :style="'left:'+sliderTime+'%'"></div>
        </div> -->
        <div v-show="show">{{music.lang}}"</div>
        <div v-show="!show">{{audio.lastTime}}"</div>
        <!-- <div>{{ audio.currentTime | formatSecond}}</div>
        <span>/</span>
        <div>{{ audio.maxTime | formatSecond}}</div> -->
      </div>
      <div :class="['audio-right',audio.playing?'active':'']"></div>
    </div>
</div>
</template>

<script>

// import a1 from '@/assets/1.mp3'
// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
    var secondType = typeof second

    if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second)

        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60

        return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
        return '0:00:00'
    }
}

export default {
    name: 'myAudio',
    props:{
      music: Object,
      index: [Number,String],
    },
    data() {
        return {
					show: true,
          sliderTime: 0,
          txt: 0,
          audio: {
            playing: false,
            currentTime: 0,
            lastTime: 0,
            maxTime: 0,
            minTime:0,
            step:0.1,
          }
        }
    },
    watch: {
      'music.speaking'(flag){
				!flag ? this.pause() : this.play()

        // if(!flag){
        //     console.log('被暂停')
        //     this.pause()
        // }
        // else{
        //     console.log('被播放')
        //     this.play()
        // }
      },
    },
    methods: {
        // 控制音频的播放与暂停
        startPlayOrPause() {
            // console.log(this.audio.playing)
            return this.audio.playing ? this.pause() : this.play()
        },
        // 播放音频
        play() {
            // console.log('你的播放开启了')
            this.$refs.audio.play()
            this.$emit('playMusic',this.index)
        },
        // 暂停音频
        pause() {
            this.$refs.audio.pause()
        },
        // 当音频播放
        onPlay() {
            // console.log('检测到你播放中')
            this.audio.playing = true
        },
        // 当音频暂停
        onPause() {
            this.audio.playing = false
        },
        handleFocus() {
            console.log('focues')
        },
        // 当加载语音流元数据完成后，会触发该事件的回调函数
        // 语音元数据主要是语音的长度之类的数据
        onLoadedmetadata(res) {
            // console.log('loadedmetadata')
            // console.log(res)
            this.audio.maxTime = parseInt(res.target.duration)
            this.audio.lastTime = this.audio.maxTime
            this.txt = 9
        },
        // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
        // 当音频当前时间改变后，进度条也要改变
        onTimeupdate(res) {
            // console.log('timeupdate')
            // console.log(res)
            this.audio.currentTime = res.target.currentTime
            let lastTime = Math.floor(this.audio.maxTime - this.audio.currentTime)
            lastTime = lastTime>=0?lastTime:0
            this.audio.lastTime = lastTime==0?this.audio.maxTime:lastTime
            this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
						this.show = false
        },

        // 进度条格式化toolTip
        formatProcessToolTip(index = 0) {
            index = parseInt(this.audio.maxTime / 100 * index)
            return '进度条: ' + realFormatSecond(index)
        },

        handleTouchStart(e) {
            this.setValue(e.touches[0]);

            document.addEventListener('touchmove', this.handleTouchMove);
            document.addEventListener('touchup', this.handleTouchEnd);
            document.addEventListener('touchend', this.handleTouchEnd);
            document.addEventListener('touchcancel', this.handleTouchEnd);

            // e.preventDefault();
            // this.onDragStart(e);
        },
        handleTouchMove(e){
            console.log(e.changedTouches[0])
            this.setValue(e.changedTouches[0]);
        },
        handleTouchEnd(e) {
            this.setValue(e.changedTouches[0]);
            document.removeEventListener('touchmove', this.handleTouchMove);
            document.removeEventListener('touchup', this.handleTouchEnd);
            document.removeEventListener('touchend', this.handleTouchEnd);
            document.removeEventListener('touchcancel', this.handleTouchEnd);
            // this.onDragStop(e);
        },
        // 从点击位置更新 value
        setValue(e) {
            const $el=this.$el;
            const {
                maxTime,
                minTime,
                step
            } = this.audio;
            let value = (e.clientX - $el.getBoundingClientRect().left) / $el.offsetWidth * (maxTime - minTime);
            value = Math.round(value / step) * step + minTime;
            value = parseFloat(value.toFixed(5));

            if (value > maxTime) {
                value = maxTime;
            } else if (value < minTime) {
                value = minTime;
            }
            this.$refs.audio.currentTime = value;
        },
        // 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
        changeCurrentTime(index) {
            console.log('拖动进度条')
            // this.audio.playing && this.pause();
            // console.log('拖动了',index,this.sliderTime,this.audio.maxTime,parseInt(index / 100 * this.audio.maxTime))
            // !this.audio.playing && this.play();
            this.$refs.audio.currentTime = parseInt(index / 100 * this.audio.maxTime)
        }
    },
    filters: {
        // 使用组件过滤器来动态改变按钮的显示
        transPlayPause(value) {
            return value ? '暂停' : '播放'
        },
        // 将整数转化成时分秒
        formatSecond(second = 0) {
            return realFormatSecond(second)
        }
    }
}
</script>

<style lang="scss" scoped>
.audio-box{
  background: #5bb65d;
  border-radius: 4px;
  overflow: hidden;
  padding: 0 10px;
  box-shadow: 3px 4px 2px #d7f0de;
  .audio-cont{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: .6rem;
    .audio-left{
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #fff;
      .play{
        width: .36rem;
        height: .36rem;
        margin-right: 5px;
        background: url('./../assets/play.png') no-repeat;
        background-size: 100%;
        &.active{
          background: url('./../assets/stop.png') no-repeat;
          background-size: 100%;
        }
      }
    }
    .audio-right{
      width: .25rem;
      height: .2rem;
      margin-top: 0rem;
      background: url('./../assets/music.png') no-repeat;
      background-size: 100%;
      &.active{
        width: .3rem;
        height: .3rem;
        margin-top: -0.12rem;
        background: url('./../assets/music.gif') no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/audio.vue